export class Calculation {
    sourceName: string;
    operator: string;
    firstOperand: string;
    secondOperand: string;
}